import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BaseCard = ({ className, ...props }) => (
  <div className={classNames('card', className)} {...props} />
);

BaseCard.propTypes = {
  className: PropTypes.string,
};

export default BaseCard;
